import * as React from "react";

import DataTable from "react-data-table-component-with-filter";
import { Link, useNavigate } from "react-router-dom";
import { RiFilterLine } from "react-icons/ri";

import Paper from "../../Components/Paper";
import Button from "../../Components/Button";
import FilterComponent from "../../Components/FilterComponent";
import { config } from "./Helper";
import { useLoader } from "../../Context/LoaderContext";
import axiosInstance from "../../Api/Axios";

import { handleDownload } from "../../Functions/Utils";

import "./ListClaim.scss";

const customStyles = {
  headCells: {
    style: {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      background: "#e75043",
      paddingBottom: "12px",
      paddingTop: "4px",
    },
  },
  cells: {
    style: {
      color: "#000",
      fontSize: "15px",
    },
  },
};

const ListClaim = () => {
  const [listClaim, setListClaim] = React.useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [withFilter, setWithFilter] = React.useState(false);

  const { setIsLoading } = useLoader();
  const navigate = useNavigate();

  React.useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/reclamations`)
      .then((response) => {
        setIsLoading(false);
        setListClaim(response.data.data || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  const filteredItems = listClaim.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );
  const subHeaderComponent = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const onView = (id) => {
    navigate(`/list-claim/add-claim/${id}`);
  };

  const handleDownloadPdf = () => {
    handleDownload("list_claim", "Reclamations");
  };

  return (
    <Paper>
      <div className="wrap-tabs-offer">
        <h1>Réclamations</h1>
        <div className="box_link_funding">
          <Link to="/list-claim/add-claim">
            <Button variant="dark">Déposez votre réclamation</Button>
          </Link>
        </div>

        {listClaim.length > 0 && (
          <div className="wrap-btn-action">
            <Button variant="dark" view="outline" onClick={handleDownloadPdf}>
              Imprimer
            </Button>
            <Button
              onClick={() => setWithFilter((prev) => !prev)}
              variant="dark"
              view="outline"
            >
              {withFilter ? "Masquer filtre" : "Afficher filtre"}
              <RiFilterLine />
            </Button>
          </div>
        )}
        <div className="print-container">
          <DataTable
            // title="Réclamation"
            columns={config(onView, withFilter)}
            data={filteredItems}
            customStyles={customStyles}
            pagination
            subHeader
            highlightOnHover
            subHeaderComponent={subHeaderComponent}
            noDataComponent={<div> Pas d'informations disponibles</div>}
            paginationComponentOptions={{
              rowsPerPageText: "Lignes par page:",
              rangeSeparatorText: "de",
              noRowsPerPage: false,
              selectAllRowsItem: false,
              selectAllRowsItemText: "tous",
            }}
          />
        </div>
      </div>
    </Paper>
  );
};

export default ListClaim;
